<template>
  <section
    :class="['zg-section', {
      [`zg-section--background-${background}`]: background,
      'zg-section--no-padding': noPadding,
      'zg-section--no-top-padding': noTopPadding,
      'zg-section--no-bottom-padding': noBottomPadding,
      'zg-section--no-x-padding': noXPadding,
      'zg-section--no-y-padding': noYPadding,
      'zg-section--base-x-padding': baseXPadding,
      'zg-section--base-y-padding': baseYPadding,
      'zg-section--medium-x-padding': mediumXPadding,
      'zg-section--medium-y-padding': mediumYPadding,
      'zg-section--extra-x-padding': extraXPadding,
      'zg-section--extra-y-padding': extraYPadding,
      'zg-section--double-x-padding': doubleXPadding,
      'zg-section--double-y-padding': doubleYPadding
    }]"
  >
    <div class="zg-section__content">
      <slot />
    </div>
  </section>
</template>

<script>
  export default {
    name: 'ZgSection',
    props: {
      background: {
        type: String,
        required: false,
        default: 'white',
        validator: value => ['white', 'beige', 'transparent', 'brand-100'].includes(value)
      },
      noPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      noXPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      noYPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      noTopPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      noBottomPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      baseXPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      baseYPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      mediumXPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      mediumYPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      extraXPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      extraYPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      doubleXPadding: {
        type: Boolean,
        required: false,
        default: false
      },
      doubleYPadding: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-section {
    display: block;
    width: 100%;
    padding: rhythm(medium) rhythm(base);

    @include mq(large) {
      padding: rhythm(double) rhythm(base);
    }
  }

  .zg-section__content {
    width: 100%;
    max-width: rem(1080px);
    margin: 0 auto;
  }

  .zg-section--background-white {
    background: color(white);
  }

  .zg-section--background-beige {
    background: color(beige);
  }

  .zg-section--background-brand-100 {
    background: color(brand-100);
  }

  .zg-section--no-padding {
    padding: 0;

    @include mq(large) {
      padding: 0;
    }
  }

  .zg-section--no-x-padding {
    padding-left: 0;
    padding-right: 0;

    @include mq(large) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .zg-section--no-y-padding {
    padding-top: 0;
    padding-bottom: 0;

    @include mq(large) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .zg-section--no-top-padding {
    padding-top: 0;

    @include mq(large) {
      padding-top: 0;
    }
  }

  .zg-section--no-bottom-padding {
    padding-bottom: 0;

    @include mq(large) {
      padding-bottom: 0;
    }
  }

  .zg-section--base-x-padding {
    padding-right: rhythm(base);
    padding-left: rhythm(base);

    @include mq(large) {
      padding-right: rhythm(base);
      padding-left: rhythm(base);
    }
  }

  .zg-section--base-y-padding {
    padding-top: rhythm(base);
    padding-bottom: rhythm(base);

    @include mq(large) {
      padding-top: rhythm(base);
      padding-bottom: rhythm(base);
    }
  }

  .zg-section--medium-x-padding {
    padding-right: rhythm(medium);
    padding-left: rhythm(medium);

    @include mq(large) {
      padding-right: rhythm(medium);
      padding-left: rhythm(medium);
    }
  }

  .zg-section--medium-y-padding {
    padding-top: rhythm(medium);
    padding-bottom: rhythm(medium);

    @include mq(large) {
      padding-top: rhythm(medium);
      padding-bottom: rhythm(medium);
    }
  }

  .zg-section--extra-x-padding {
    padding-right: rhythm(large);
    padding-left: rhythm(large);

    @include mq(large) {
      padding-right: rhythm(large);
      padding-left: rhythm(large);
    }
  }

  .zg-section--extra-y-padding {
    padding-top: rhythm(large);
    padding-bottom: rhythm(large);

    @include mq(large) {
      padding-top: rhythm(large);
      padding-bottom: rhythm(large);
    }
  }

  .zg-section--double-x-padding {
    padding-right: rhythm(double);
    padding-left: rhythm(double);

    @include mq(large) {
      padding-right: rhythm(double);
      padding-left: rhythm(double);
    }
  }

  .zg-section--double-y-padding {
    padding-top: rhythm(double);
    padding-bottom: rhythm(double);

    @include mq(large) {
      padding-top: rhythm(double);
      padding-bottom: rhythm(double);
    }
  }
</style>
